import { mapGetters } from 'vuex';
import vuexViewportMixin from 'vue/vuex/modules/viewport/mixin';
import vuexScrollMixin from 'vue/vuex/modules/scroll/mixin';


window.googleRecaptchaCallback = function() {
    globals.state.googleRecaptchaLoaded = true;
};



export default {
    mixins: [
        vuexViewportMixin,
        vuexScrollMixin,
    ],
    el: '.skel',
    data() {
        return {
            globals,
        };
    },
    computed: {
        ...mapGetters(['partials', 'theme', 'navTheme', 'cookieConsentData']),
        themeClasses() {
            return [
                `theme__${ this.theme }`,
            ];
        },
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/base/app-root.js